<script lang="ts" setup>
import { PhArrowRight } from '@phosphor-icons/vue'
import { computed } from 'vue'

const props = defineProps<{
  title?: string
  errors?: Record<string, string | undefined>
}>()

const hasErrors = computed(() => {
  return Object.values(props.errors ?? {}).some((error) => error)
})

const errorMessages = computed(() => {
  return Object.values(props.errors ?? {}).filter((error) => error)
})

</script>

<template>
  <div v-if="hasErrors"
       class="flex flex-col gap-2 bg-negative-foreground text-white py-4 px-3.5 rounded-md">
    <h3 v-if="title"
        class="text-heading-md font-heading font-normal pb-4">
      {{ title }}
    </h3>
    <ul class="list-disc pl-6 text-ui-lg font-ui font-normal underline space-y-2">
      <li v-for="(error, index) in errorMessages"
          :key="index"
          class="marker:text-ui-sm">
        <span class="flex items-center gap-2">
          {{ error }}
          <PhArrowRight class="shrink-0" />
        </span>
      </li>
    </ul>
  </div>
</template>
